export default __webpack_public_path__ + "static/media/phoneMarketMb2.3ef718d8.png";